import { createContext, useContext } from 'react';

import { AppConfigResponseDto } from '@/api/generated';

export type AppConfigContextValue = {
  config: AppConfigResponseDto;
  dataReady: boolean;
  isCommissionEnabled: boolean;
  isEmailEnabled: boolean;
  isEmergencyContactsEnabled: boolean;
};

const defaultConfig: AppConfigResponseDto = {
  commissionEnabled: false,
  emailEnabled: false,
  emergencyContactsEnabled: false,
};

export const AppConfigDefaultValues: AppConfigContextValue = {
  config: defaultConfig,
  dataReady: false,
  isCommissionEnabled: false,
  isEmailEnabled: true,
  isEmergencyContactsEnabled: false,
};

export const AppConfigContext = createContext<AppConfigContextValue>(AppConfigDefaultValues);

export const useAppConfig = (): AppConfigContextValue => {
  return useContext(AppConfigContext);
};
